import * as React from 'react';
import { useField } from 'formik';
import _ from 'lodash';
import {
  FormControl,
  FormControlProps,
  withFormControl,
  FormControlComponentDefaultProps,
  WithFormControlProps,
} from '../FormControl';
import {isRecId} from "../utils";


export const withFormikFormControl = (defaultProps: any = {}) => {
  return function withFormikFormControlWrapper<T extends FormControlComponentDefaultProps>(
    Component: React.ComponentType<T>,
  ) {
    return function ComponentWithFormikFormControl(props: T & WithFormControlProps) {
      const ComponentWithFormControl = React.useMemo(() => withFormControl(Component), [Component]);
      const [field, meta, helpers] = useField(props.name);
      const isError = meta.error ? (isRecId( _.get(props,'details.record_id')) ? props['submitPressed'] || meta.touched : props['submitPressed'] || !_.isEmpty(field.value) || meta.touched) : false
      if(meta.error)console.log('Formik Field Error', props.name, isError, field, meta, props)
      console.log('Form  Field', field.name, field.value)
      return (
        <ComponentWithFormControl
          {...defaultProps}
          errorMessage={isError ? meta.error : ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={field.value}
          {...props}
        />
      );
    };
  };
};
